import React from 'react';

import { IWorkContext } from './work.typings';

export const WorkContext = React.createContext({} as IWorkContext);
